module.exports = __webpack_public_path__ + "static/media/cherrytomato.3528701b.png";